import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './Hierarchy.scss';

import HierarchyView from './elements/HierarchyView';
import HierarchyEdit from './elements/HierarchyEdit';

import { syncCatalogHierarchy } from '../../actions/catalogActions';
import { useCatalogHierarchy } from '../../hooks/useCatalogHierarchy';

const Hierarchy = props => {
  const { syncCatalogHierarchy } = props;
  const catalog = useCatalogHierarchy();
  const [selectedItem, setSelectedItem] = React.useState(null);

  const selectItem = selectedItem => setSelectedItem(selectedItem);

  // Figure out what type is selected
  let selectedItemType;

  if (!selectedItem) selectedItemType = null;
  // Tags are unique here
  else if ('Department_id' in selectedItem && 'Category_id' in selectedItem) selectedItemType = 'tag';
  // Otherwise, check parent foreign key
  else if ('Industry_id' in selectedItem) selectedItemType = 'department';
  else if ('Department_id' in selectedItem) selectedItemType = 'category';
  else selectedItemType = 'industry';

  return (
    <div className='hierarchy-outer-container'>
      <HierarchyView
        catalog={catalog}
        syncCatalogHierarchy={syncCatalogHierarchy}
        selectedItem={selectedItem}
        selectedItemType={selectedItemType}
        selectItem={selectItem}
      />
      <HierarchyEdit
        catalog={catalog}
        syncCatalogHierarchy={syncCatalogHierarchy}
        selectedItem={selectedItem}
        selectedItemType={selectedItemType}
        selectItem={selectItem}
      />
    </div>
  );
};

Hierarchy.propTypes = {
  syncCatalogHierarchy: PropTypes.func.isRequired
};

export default connect(null, {
  syncCatalogHierarchy
})(Hierarchy);
